import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=6e907652"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports